import { RequestedItem, RouteItem } from '@/types/route';

export enum ActionTypes {
  SAVE_ITEMS = 'router/SAVE_ITEMS',
  SAVE_REQUESTED = 'router/SAVE_REQUESTED',
  CLEAR_ROUTER = 'router/CLEAR_ROUTER',
}

export interface State {
  items: RouteItem[];
  requested: RequestedItem[];
}

export interface SaveItems {
  type: ActionTypes.SAVE_ITEMS;
  payload: RouteItem[];
}
export interface SaveRequested {
  type: ActionTypes.SAVE_REQUESTED;
  payload: RequestedItem[];
}
export interface ClearRouter {
  type: ActionTypes.CLEAR_ROUTER;
}

export type ActionType = SaveItems | SaveRequested | ClearRouter;
